export enum Messages {
  MessageYellowSlot = 'MessageYellowSlot',
  MessageWhyChoose = 'MessageWhyChoose',
  MessageNewYearDraw = 'MessageNewYearDraw',
  February23rdNotice = 'February23rdNotice',
  InfoJob = 'InfoJob',
}

export interface InfoMessageSchema {
  [Messages.MessageYellowSlot]: boolean;
  [Messages.MessageWhyChoose]: boolean;
  [Messages.MessageNewYearDraw]: boolean;
  [Messages.February23rdNotice]: boolean;
  [Messages.InfoJob]: boolean;
}
